<section class="modal">
  <form [formGroup]="form" (ngSubmit)="saveBeneficiary()">
    <div>
      <span class="text-size-18 text-bold-700" mat-dialog-title>Editar Beneficiário</span>
    </div>

    <div class="d-flex direction-column row-gap-40 ptb-40">
      <div class="d-flex flex-1 column-gap-20">
        <!-- <app-c-input-filter
          class="form-input flex-1"
          label="CNPJ Beneficiário"
          formControlName="Document"
          inputMask="00.000.000/0000-00"
          [searchList]="beneficiaryDocuments"
        ></app-c-input-filter> -->

        <app-c-input
          class="form-input flex-1"
          label="CNPJ Beneficiário"
          formControlName="Document"
          inputMask="AA.AAA.AAA/AAAA-00"
          [uppercase]="true"
          inputType="text"
        >
        </app-c-input>

        <app-c-input
          class="form-input flex-1"
          label="Comissão %"
          formControlName="Comission"
          inputType="number"
        >
        </app-c-input>
      </div>
      <div class="d-flex flex-1 column-gap-20">
        <app-c-input
          class="form-input flex-1"
          label="Beneficiário"
          formControlName="BeneficiaryName"
        >
        </app-c-input>
      </div>
    </div>

    <div class="d-flex justify-space-around">
      <button type="button" class="ui-btn ui-btn--secondary w-150 h-36" mat-dialog-close>
        Cancelar
      </button>
      <button class="ui-btn ui-btn--primary w-150 h-36" [disabled]="form.invalid">
        Salvar
      </button>
    </div>
  </form>
</section>
